var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "react", "prop-types", "../../UI/Icon/Icon", "../../utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("react"), require("prop-types"), require("../../UI/Icon/Icon"), require("../../utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.objectWithoutProperties, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.react, global.propTypes, global.Icon, global.utils);
    global.SearchInput = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _objectWithoutProperties2, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _react, _propTypes, _Icon, _utils) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _Icon = _interopRequireDefault(_Icon);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var SearchInput = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(SearchInput, _PureComponent);

    var _super = _createSuper(SearchInput);

    function SearchInput(props) {
      var _this;

      (0, _classCallCheck2.default)(this, SearchInput);
      _this = _super.call(this, props);
      _this.state = {
        value: props.value
      };
      return _this;
    }

    (0, _createClass2.default)(SearchInput, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            className = _this$props.className,
            disabled = _this$props.disabled,
            handleChange = _this$props.handleChange,
            labels = _this$props.labels,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "disabled", "handleChange", "labels"]);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(className, "__input")
        }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, rest, {
          autoFocus: true,
          type: "search",
          placeholder: labels.placeholder,
          value: this.state.value,
          disabled: disabled,
          "aria-label": labels.ariaLabel,
          onChange: function onChange(event) {
            _this2.setState({
              value: event.target.value
            });

            handleChange(event.target.value);
          }
        })), /*#__PURE__*/_react.default.createElement(_Icon.default, {
          className: "".concat(className, "__icon"),
          name: "arte-next-nav-search"
        }));
      }
    }]);
    return SearchInput;
  }(_react.PureComponent);

  SearchInput.propTypes = {
    className: _propTypes.default.string,
    handleChange: _propTypes.default.func.isRequired,
    disabled: _propTypes.default.bool,
    labels: _propTypes.default.shape({
      ariaLabel: _propTypes.default.string,
      placeholder: _propTypes.default.string,
      searchProgram: _propTypes.default.string,
      searchResult: _propTypes.default.string
    }).isRequired,
    value: _propTypes.default.string
  };
  SearchInput.defaultProps = {
    className: 'next-searchbar',
    handleChange: function handleChange(text) {
      return console.log(text);
    },
    disabled: false,
    labels: {
      ariaLabel: 'Search for a program, results will be displayed automatically.',
      placeholder: 'Search',
      searchProgram: 'Search for a program',
      searchResult: 'Search results for %{searchValue}'
    },
    value: ''
  };
  var _default = SearchInput;
  _exports.default = _default;
});